import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callOperation } from "async-ops";
import { SMARTSCAN_POLL_INBOX_STATUS, SMARTSCAN_STATUS } from "./services/poll-smartscan-inbox-status";
import { SMARTSCAN_UPDATE_INBOX_LIST } from "./reducers/emdr-ibox-reducer";
import { EMDR_INBOX_PAGE_TABS } from "../constant";

const POLL_INTERVAL_MS = 3_000;

/**
 * Polls GetEMDRInboxList every 3 seconds while any inbox item has SmartScanStatus=INPROGRESS.
 * Stops automatically once none remain or the component unmounts.
 *
 * @param type - Active tab type (EMDR_INBOX_PAGE_TABS.INBOX_TAB or HISTORY_TAB).
 *               Polling is skipped entirely when not on the Inbox tab.
 */
export function useSmartScanInboxPolling(type: string) {
  const dispatch = useDispatch();
  const eMDRInboxList = useSelector((state: any) => state["emdrInboxReducer"].eMDRInboxList);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    clearTimer();

    if (type !== EMDR_INBOX_PAGE_TABS.INBOX_TAB) return;

    const hasInProgress = eMDRInboxList?.some(
      (item: any) => item.smartScanStatus === SMARTSCAN_STATUS.INPROGRESS
    );

    if (hasInProgress) {
      timerRef.current = setTimeout(() => {
        callOperation(SMARTSCAN_POLL_INBOX_STATUS, { type })
          .then((response: any) => {
            dispatch({ type: SMARTSCAN_UPDATE_INBOX_LIST, data: response.eMDRInboxList });
          })
          .catch(() => {});
      }, POLL_INTERVAL_MS);
    }

    return () => clearTimer();
  }, [eMDRInboxList, type]);
}
